export const faqItems = [
  {
    question: '正常的阴道分泌物应该是什么样子的？',
    answer: '正常的阴道分泌物通常呈白色或透明状，质地可以是稀薄或稍微粘稠，略带酸味或无味。分泌物的量和质地会随着月经周期变化而改变：排卵期分泌物增多、变稀薄如蛋清样；月经前后分泌物较粘稠。只要没有异味、不引起瘙痒或不适，通常都是正常的。',
  },
  {
    question: '每天需要用洗液清洗私处吗？',
    answer: '不需要。阴道具有自洁功能，日常用温水清洗外阴即可，不需要使用任何洗液灌洗阴道内部。过度使用碱性洗液或抗菌产品会破坏阴道正常的酸性环境和菌群平衡，反而增加感染风险。洗净双手后用流动温水从前向后清洗外阴是最安全的方式。',
  },
  {
    question: '阴道炎会自己好吗？',
    answer: '轻微的阴道菌群失调在去除诱因后（如停用抗生素、换掉过紧的裤子等）有可能自行恢复。但如果出现明显症状如瘙痒、灼痛、异常分泌物等，建议及时就医明确诊断。不同类型的阴道炎需要不同的治疗方案，错误用药可能加重病情。尤其是初次出现症状时，不建议自行用药。',
  },
  {
    question: '如何维持阴道菌群平衡？',
    answer: '维持阴道菌群平衡的关键措施包括：① 避免过度清洁和阴道灌洗；② 选择纯棉透气内衣，避免长时间穿紧身裤；③ 排便后从前向后擦拭；④ 均衡饮食，适量补充益生菌；⑤ 避免滥用抗生素；⑥ 保持健康的生活方式，规律作息，适度运动；⑦ 性生活注意卫生。',
  },
  {
    question: '多少岁开始需要做妇科检查？',
    answer: '一般建议女性从21岁开始或有性生活后开始定期进行妇科检查。21-29岁的女性建议每3年做一次TCT宫颈细胞学检查；30-65岁建议每5年做一次TCT+HPV联合筛查。即使没有不适症状，定期检查也非常重要，因为很多妇科疾病早期没有明显症状。',
  },
  {
    question: '穿紧身裤对私密健康有影响吗？',
    answer: '有影响。长期穿紧身裤、化纤内裤等不透气的衣物会造成私密部位局部温度升高、湿度增加，为细菌和真菌的繁殖创造了有利条件。建议日常多穿透气性好的纯棉内衣和宽松裤子，运动后及时更换汗湿的衣物，保持私处干爽。',
  },
  {
    question: '月经期间可以清洗私处吗？',
    answer: '可以而且应该。月经期间更需要注意私处清洁。建议每天用温水清洗外阴1-2次，每2-4小时更换卫生巾或卫生棉条。清洗时同样只需要清洗外阴，不需要灌洗阴道内部。保持清洁干爽可以有效减少经期感染风险。',
  },
  {
    question: '吃益生菌对阴道健康有用吗？',
    answer: '有一定帮助。研究显示，含有乳酸杆菌等特定菌株的益生菌补充剂可能有助于维持阴道菌群平衡，特别是在使用抗生素后或反复发生阴道炎的情况下。不过益生菌不能替代药物治疗，如果有明显症状应当先就医。日常可以通过酸奶、发酵食品等天然方式补充益生菌。',
  },
];